export const iconFontAwesomeBuildingsLandmark = (
	<i className="fa-solid fa-landmark"></i>
);
